import { createAction } from "@reduxjs/toolkit";
import type { BatchStudent } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveEducationalAdvisorStudentByEmail = createApiThunk<Nullable<BatchStudent>, string>(
  "educationalAdvisor/retrieveEducationalAdvisorStudentByEmail",
  async (email: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getStudentByEmail(email);
  },
);

export const resetRetrieveEducationalAdvisorStudentByEmail = createAction(
  "educationalAdvisor/resetRetrieveEducationalAdvisorStudentByEmail",
);
